var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-chart",style:({
  width: _vm.config.chartWidth + 'px',
  height: _vm.config.chartHeight + 'px',
})},[(_vm.imgUrl)?_c('img',{staticClass:"image-chart-img",style:({ display: 'inline-block', width: '100%', height: '100%' }),attrs:{"src":_vm.imgUrl,"alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }